// Ejemplos: pantallas y luces (OLED, 7 segmentos, TM1637, MAX7219, NeoPixel y barra de LEDs).
import { at, part, wires, UNO } from './helpers.js';

const BB = { id: 'bb1', type: 'breadboard', x: 0, z: -80, rot: 0, props: { size: 'half' } };

const OLED_ADAFRUIT = `// Pantalla OLED de 0.96" (SSD1306, 128x64, I2C en la dirección 0x3C) con Adafruit_SSD1306.
// SDA va a A4 y SCL a A5. En la versión amarilla y azul, las 16 filas de arriba son amarillas.
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>

Adafruit_SSD1306 oled(128, 64, &Wire, -1);   // -1: el módulo no tiene pin de reset

int x = 20, y = 40, dx = 2, dy = 1;          // posición y velocidad de la pelota

void setup() {
  Serial.begin(9600);
  // SSD1306_SWITCHCAPVCC: el voltaje del panel sale de la bomba de carga interna
  if (!oled.begin(SSD1306_SWITCHCAPVCC, 0x3C)) {
    Serial.println(F("No se pudo iniciar la OLED"));
    for (;;);
  }
  oled.setTextColor(SSD1306_WHITE);
}

void loop() {
  oled.clearDisplay();               // borra el búfer (en la RAM del Arduino)

  // Barra de título en la zona amarilla
  oled.setTextSize(1);
  oled.setCursor(4, 4);
  oled.print(F("Arduino 3D"));
  oled.setCursor(92, 4);
  oled.print(millis() / 1000);
  oled.print('s');
  oled.drawFastHLine(0, 15, 128, SSD1306_WHITE);

  // Marco y pelota que rebota en la zona azul
  oled.drawRect(0, 18, 128, 46, SSD1306_WHITE);
  x += dx;
  y += dy;
  if (x <= 4 || x >= 123) dx = -dx;
  if (y <= 22 || y >= 59) dy = -dy;
  oled.fillCircle(x, y, 3, SSD1306_WHITE);

  oled.display();                    // manda los 1024 bytes a la pantalla
  delay(20);
}
`;

const OLED_U8G2 = `// OLED con la librería U8g2: texto con distintas fuentes y una onda senoidal que avanza.
// SDA va a A4 y SCL a A5.
#include <U8g2lib.h>
#include <Wire.h>

// SSD1306 de 128x64, búfer completo (F), I2C por hardware, dirección 0x3C por omisión
U8G2_SSD1306_128X64_NONAME_F_HW_I2C u8g2(U8G2_R0, U8X8_PIN_NONE);

float fase = 0;

void setup() {
  u8g2.begin();
}

void loop() {
  u8g2.clearBuffer();
  u8g2.setFont(u8g2_font_helvB10_tr);
  u8g2.drawStr(0, 12, "U8g2 + SSD1306");
  u8g2.setFont(u8g2_font_5x7_tr);
  u8g2.drawStr(0, 23, "onda senoidal:");
  u8g2.drawHLine(0, 45, 128);
  for (int x = 0; x < 128; x++) {
    int y = 45 + 15 * sin(fase + x * 0.1);
    u8g2.drawPixel(x, y);
  }
  u8g2.sendBuffer();
  fase += 0.25;
}
`;

const SIETE_SEGMENTOS = `// Display de 7 segmentos de cátodo común: cuenta de 0 a 9 con el punto decimal parpadeando.
// Segmentos A–G y DP en los pines 2–9, cada uno con su resistencia de 220 Ω. COM va a GND.
const int PINES[8] = {2, 3, 4, 5, 6, 7, 8, 9};   // A, B, C, D, E, F, G, DP

// Segmentos encendidos de cada número (bits: DP G F E D C B A)
const byte DIGITOS[10] = {
  0b00111111,  // 0
  0b00000110,  // 1
  0b01011011,  // 2
  0b01001111,  // 3
  0b01100110,  // 4
  0b01101101,  // 5
  0b01111101,  // 6
  0b00000111,  // 7
  0b01111111,  // 8
  0b01101111,  // 9
};

void mostrar(byte segmentos) {
  for (int i = 0; i < 8; i++) digitalWrite(PINES[i], bitRead(segmentos, i));
}

void setup() {
  for (int i = 0; i < 8; i++) pinMode(PINES[i], OUTPUT);
}

void loop() {
  for (int n = 0; n <= 9; n++) {
    mostrar(DIGITOS[n]);
    delay(500);
    mostrar(DIGITOS[n] | 0b10000000);   // con el punto decimal
    delay(500);
  }
}
`;

const SEVSEG = `// Cronómetro en un display de 4 dígitos con la librería SevSeg (cuenta décimas de segundo).
// Los segmentos son comunes a los 4 dígitos: SevSeg los multiplexa muy rápido.
// Dígitos D1–D4 en los pines 2–5 (con resistencias de 330 Ω); segmentos A–G y DP en los pines 6–13.
#include <SevSeg.h>

SevSeg pantalla;

void setup() {
  byte digitos[] = {2, 3, 4, 5};
  byte segmentos[] = {6, 7, 8, 9, 10, 11, 12, 13};   // A, B, C, D, E, F, G, DP
  bool resistenciasEnSegmentos = false;               // aquí están en los dígitos
  pantalla.begin(COMMON_CATHODE, 4, digitos, segmentos, resistenciasEnSegmentos);
  pantalla.setBrightness(90);
}

void loop() {
  static unsigned long antes = 0;
  static int decimas = 0;
  if (millis() - antes >= 100) {
    antes += 100;
    decimas = (decimas + 1) % 10000;
    pantalla.setNumber(decimas, 1);   // un decimal: 123.4
  }
  pantalla.refreshDisplay();          // hay que llamarla sin parar
}
`;

const TM1637_RELOJ = `// Reloj con el módulo TM1637: minutos y segundos desde el arranque, con los dos puntos parpadeando.
// CLK en el pin 2 y DIO en el 3 (sirve cualquier par de pines).
#include <TM1637Display.h>

const int CLK = 2;
const int DIO = 3;
TM1637Display display(CLK, DIO);

void setup() {
  display.setBrightness(5);   // 0 (tenue) a 7 (máximo)
  const uint8_t hola[] = {
    SEG_B | SEG_C | SEG_E | SEG_F | SEG_G,           // H
    SEG_A | SEG_B | SEG_C | SEG_D | SEG_E | SEG_F,   // O
    SEG_D | SEG_E | SEG_F,                           // L
    SEG_A | SEG_B | SEG_C | SEG_E | SEG_F | SEG_G,   // A
  };
  display.setSegments(hola);
  delay(1500);
}

void loop() {
  unsigned long s = millis() / 1000;
  int mmss = (s / 60) % 60 * 100 + s % 60;
  bool puntos = (millis() / 500) % 2 == 0;
  display.showNumberDecEx(mmss, puntos ? 0b01000000 : 0, true);   // el bit 0x40 son los dos puntos
  delay(100);
}
`;

const MATRIZ_LEDCONTROL = `// Matriz LED de 8x8 con MAX7219 y la librería LedControl: caras y un barrido.
// DIN en el pin 12, CLK en el 11 y CS en el 10.
#include <LedControl.h>

LedControl matriz(12, 11, 10, 1);   // DIN, CLK, CS y cuántos módulos hay en cadena

const byte FELIZ[8]  = {B00111100, B01000010, B10100101, B10000001, B10100101, B10011001, B01000010, B00111100};
const byte SERIO[8]  = {B00111100, B01000010, B10100101, B10000001, B10111101, B10000001, B01000010, B00111100};
const byte TRISTE[8] = {B00111100, B01000010, B10100101, B10000001, B10011001, B10100101, B01000010, B00111100};

void dibujar(const byte *imagen) {
  for (int fila = 0; fila < 8; fila++) matriz.setRow(0, fila, imagen[fila]);
}

void setup() {
  matriz.shutdown(0, false);   // el MAX7219 arranca apagado
  matriz.setIntensity(0, 6);   // brillo de 0 a 15
  matriz.clearDisplay(0);
}

void loop() {
  dibujar(FELIZ);
  delay(1000);
  dibujar(SERIO);
  delay(1000);
  dibujar(TRISTE);
  delay(1000);
  matriz.clearDisplay(0);
  for (int fila = 0; fila < 8; fila++) {
    for (int col = 0; col < 8; col++) {
      matriz.setLed(0, fila, col, true);
      delay(15);
    }
  }
}
`;

const PAROLA = `// Texto que se desplaza en una matriz de 32x8 (cuatro MAX7219, placa FC-16) con MD_Parola.
// SPI por hardware: DIN al pin 11 (MOSI), CLK al 13 (SCK) y CS al 10.
#include <MD_Parola.h>
#include <MD_MAX72xx.h>
#include <SPI.h>

#define HARDWARE_TYPE MD_MAX72XX::FC16_HW
#define MAX_DEVICES 4
#define CS_PIN 10

MD_Parola pantalla(HARDWARE_TYPE, CS_PIN, MAX_DEVICES);

void setup() {
  pantalla.begin();
  pantalla.setIntensity(4);   // 0 a 15
  // texto, alineación, velocidad (ms por paso), pausa, efecto de entrada y de salida
  pantalla.displayText("Hola, Arduino 3D!", PA_CENTER, 50, 1000, PA_SCROLL_LEFT, PA_SCROLL_LEFT);
}

void loop() {
  if (pantalla.displayAnimate()) pantalla.displayReset();   // al terminar, vuelve a empezar
}
`;

const ANILLO = `// Anillo de 16 NeoPixel (WS2812B) con Adafruit_NeoPixel: un arcoíris que gira y un cometa.
// DIN al pin 6. Cada LED recibe 24 bits (verde, rojo, azul) por el mismo cable.
#include <Adafruit_NeoPixel.h>

const int PIN = 6;
const int NUM = 16;
Adafruit_NeoPixel anillo(NUM, PIN, NEO_GRB + NEO_KHZ800);

void setup() {
  anillo.begin();
  anillo.setBrightness(60);   // 0–255
  anillo.show();              // empieza apagado
}

void loop() {
  // Arcoíris que da dos vueltas
  for (long inicio = 0; inicio < 2 * 65536L; inicio += 1024) {
    for (int i = 0; i < NUM; i++) {
      long tono = inicio + i * 65536L / NUM;
      anillo.setPixelColor(i, anillo.gamma32(anillo.ColorHSV(tono)));
    }
    anillo.show();
    delay(15);
  }
  // Cometa azul con estela
  for (int paso = 0; paso < 3 * NUM; paso++) {
    for (int i = 0; i < NUM; i++) {
      int d = (paso - i + NUM) % NUM;
      anillo.setPixelColor(i, d < 4 ? anillo.Color(0, 120 >> d, 255 >> d) : 0);
    }
    anillo.show();
    delay(40);
  }
}
`;

const ESCANER = `// Tira de 8 NeoPixel con FastLED: el «escáner» de luz roja que va y viene.
// DIN al pin 5.
#include <FastLED.h>

#define PIN 5
#define NUM 8
CRGB leds[NUM];

void setup() {
  FastLED.addLeds<WS2812B, PIN, GRB>(leds, NUM);
  FastLED.setBrightness(150);
}

void paso(int pos) {
  fadeToBlackBy(leds, NUM, 150);   // deja una estela que se apaga
  leds[pos] = CRGB::Red;
  FastLED.show();
  delay(70);
}

void loop() {
  for (int i = 0; i < NUM; i++) paso(i);
  for (int i = NUM - 2; i > 0; i--) paso(i);
}
`;

const MATRIZ_NEOPIXEL = `// Matriz NeoPixel de 8x8: un corazón que late sobre un fondo de arcoíris.
// Los 64 LEDs van en filas: el 0 arriba a la izquierda y el 63 abajo a la derecha. DIN al pin 3.
#include <Adafruit_NeoPixel.h>

const int PIN = 3;
Adafruit_NeoPixel matriz(64, PIN, NEO_GRB + NEO_KHZ800);

const byte CORAZON[8] = {
  0b01100110,
  0b11111111,
  0b11111111,
  0b11111111,
  0b01111110,
  0b00111100,
  0b00011000,
  0b00000000,
};

void setup() {
  matriz.begin();
  matriz.setBrightness(50);
}

void loop() {
  unsigned long t = millis();
  int latido = 128 + 127 * sin(t / 160.0);        // 1..255
  for (int fila = 0; fila < 8; fila++) {
    for (int col = 0; col < 8; col++) {
      uint32_t color;
      if (bitRead(CORAZON[fila], 7 - col)) color = matriz.Color(latido, 0, latido / 8);
      else color = matriz.ColorHSV(t * 24 + (fila + col) * 4096, 255, 70);
      matriz.setPixelColor(fila * 8 + col, color);
    }
  }
  matriz.show();
  delay(20);
}
`;

const ANILLO_RGBW = `// Anillo de 16 NeoPixel RGBW (SK6812) con Adafruit_NeoPixel: además de rojo, verde y azul, cada LED tiene un LED blanco.
// Con NEO_GRBW cada LED recibe 32 bits (verde, rojo, azul y blanco) y Color() lleva un cuarto valor: el blanco. DIN al pin 6.
// Tres escenas de 4 s: 1) mitad izquierda con el «blanco» que se arma con rojo + verde + azul (más frío) y mitad derecha
// con el LED blanco; 2) el canal blanco respira; 3) un punto de color con una estela blanca que gira.
#include <Adafruit_NeoPixel.h>

const int PIN = 6;
const int NUM = 16;
Adafruit_NeoPixel anillo(NUM, PIN, NEO_GRBW + NEO_KHZ800);

void setup() {
  anillo.begin();
  anillo.setBrightness(160);   // 0–255
}

void loop() {
  unsigned long t = millis() % 12000;
  anillo.clear();
  if (t < 4000) {
    for (int i = 0; i < NUM; i++) {
      anillo.setPixelColor(i, i < NUM / 2 ? anillo.Color(255, 255, 255, 0) : anillo.Color(0, 0, 0, 255));
    }
  } else if (t < 8000) {
    int nivel = 127 + 127 * sin((t - 4000) * 2 * PI / 2000.0);   // dos respiraciones
    for (int i = 0; i < NUM; i++) anillo.setPixelColor(i, anillo.Color(0, 0, 0, nivel));
  } else {
    int cabeza = ((t - 8000) / 100) % NUM;
    for (int k = 0; k < 6; k++) {
      int i = (cabeza - k + NUM) % NUM;
      if (k == 0) anillo.setPixelColor(i, anillo.Color(255, 0, 90, 0));
      else anillo.setPixelColor(i, anillo.Color(0, 0, 0, 220 - k * 40));
    }
  }
  anillo.show();
  delay(20);
}
`;

const TIRA_RGBW = `// Tira NeoPixel RGBW de 8 LEDs (SK6812) con Adafruit_NeoPixel: del rojo al blanco con el canal W.
// En el LED 0 solo brilla el rojo y en el 7 solo el LED blanco; en medio se mezclan (rojo + blanco da rosa). DIN al pin 5.
#include <Adafruit_NeoPixel.h>

const int PIN = 5;
const int NUM = 8;
Adafruit_NeoPixel tira(NUM, PIN, NEO_GRBW + NEO_KHZ800);

void setup() {
  tira.begin();
  tira.setBrightness(150);
  for (int i = 0; i < NUM; i++) {
    int blanco = 255L * i / (NUM - 1);
    tira.setPixelColor(i, tira.Color(255 - blanco, 0, 0, blanco));   // rojo, verde, azul, blanco
  }
  tira.show();
}

void loop() {}
`;

const MATRIZ_RGBW = `// Matriz NeoPixel RGBW 8x8 (SK6812): copos de nieve (el LED blanco, canal W) que caen sobre un fondo azul oscuro.
// Los 64 LEDs van en filas: el 0 arriba a la izquierda. DIN al pin 3.
#include <Adafruit_NeoPixel.h>

const int PIN = 3;
Adafruit_NeoPixel matriz(64, PIN, NEO_GRBW + NEO_KHZ800);
byte copo[8];   // fila del copo de cada columna (255 = sin copo)

void setup() {
  matriz.begin();
  matriz.setBrightness(120);
  for (int c = 0; c < 8; c++) copo[c] = 255;
  randomSeed(analogRead(A0));
}

void loop() {
  for (int c = 0; c < 8; c++) {
    if (copo[c] == 255) {
      if (random(6) == 0) copo[c] = 0;           // nace un copo arriba
    } else if (++copo[c] > 7) {
      copo[c] = 255;                             // sale por abajo
    }
  }
  for (int fila = 0; fila < 8; fila++) {
    for (int c = 0; c < 8; c++) {
      matriz.setPixelColor(fila * 8 + c, copo[c] == fila ? matriz.Color(0, 0, 0, 255) : matriz.Color(0, 2, 10, 0));
    }
  }
  matriz.show();
  delay(150);
}
`;

const BARRA = `// Gráfica de barras: la perilla (A0) decide cuántos LEDs de la barra se encienden.
// Ánodos de la barra en los pines 2–11; cada cátodo va a GND con una resistencia de 220 Ω.
const int SENSOR = A0;
const int LEDS = 10;
const int PINES[LEDS] = {2, 3, 4, 5, 6, 7, 8, 9, 10, 11};

void setup() {
  for (int i = 0; i < LEDS; i++) pinMode(PINES[i], OUTPUT);
}

void loop() {
  int lectura = analogRead(SENSOR);
  int nivel = map(lectura, 0, 1023, 0, LEDS);
  for (int i = 0; i < LEDS; i++) digitalWrite(PINES[i], i < nivel ? HIGH : LOW);
}
`;

const NEOPIXEL_5MM = `// Tres LEDs NeoPixel de 5 mm en cadena: el DOUT de cada uno va al DIN del siguiente.
// DIN del primero al pin 6; los tres toman 5 V y GND de los rieles de la protoboard.
#include <Adafruit_NeoPixel.h>

const int PIN = 6;
const int N = 3;
Adafruit_NeoPixel leds(N, PIN, NEO_GRB + NEO_KHZ800);

void setup() {
  leds.begin();
  leds.setBrightness(90);
}

void loop() {
  // Rojo, verde y azul que avanzan por la cadena
  uint32_t colores[3] = {leds.Color(255, 0, 0), leds.Color(0, 255, 0), leds.Color(0, 0, 255)};
  for (int paso = 0; paso < 6; paso++) {
    for (int i = 0; i < N; i++) leds.setPixelColor(i, colores[(i + paso) % 3]);
    leds.show();
    delay(400);
  }
  // Arcoíris desfasado en cada LED
  for (long tono = 0; tono < 65536L; tono += 512) {
    for (int i = 0; i < N; i++) leds.setPixelColor(i, leds.gamma32(leds.ColorHSV(tono + i * 21845L)));
    leds.show();
    delay(10);
  }
}
`;

const OLED32 = `// OLED de 0.91" (128x32, SSD1306) con Adafruit_SSD1306: texto grande y una barra de progreso.
// SDA va a A4 y SCL a A5.
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>

Adafruit_SSD1306 oled(128, 32, &Wire, -1);   // alto de 32 filas

void setup() {
  oled.begin(SSD1306_SWITCHCAPVCC, 0x3C);
  oled.setTextColor(SSD1306_WHITE);
}

void loop() {
  unsigned long s = millis() / 1000;
  oled.clearDisplay();
  oled.setTextSize(2);
  oled.setCursor(0, 0);
  oled.print(s / 60);
  oled.print(':');
  if (s % 60 < 10) oled.print('0');
  oled.print(s % 60);
  oled.setTextSize(1);
  oled.setCursor(76, 4);
  oled.print(F("minutos"));
  int ancho = (millis() % 1000) * 128L / 1000;     // avanza cada segundo
  oled.drawRect(0, 22, 128, 10, SSD1306_WHITE);
  oled.fillRect(2, 24, ancho * 124 / 128, 6, SSD1306_WHITE);
  oled.display();
  delay(30);
}
`;

const MAX7SEG_CODE = `// Display de 8 dígitos con MAX7219 y LedControl: «HOLA» y luego un contador.
// DIN en el pin 12, CLK en el 11 y CS en el 10. El dígito 0 es el de la derecha.
#include <LedControl.h>

LedControl display(12, 11, 10, 1);   // DIN, CLK, CS y cuántos módulos hay en cadena

void mostrarNumero(long n) {
  for (int i = 0; i < 8; i++) {
    if (n == 0 && i > 0) display.setChar(0, i, ' ', false);   // sin ceros a la izquierda
    else display.setDigit(0, i, n % 10, false);
    n /= 10;
  }
}

void setup() {
  display.shutdown(0, false);   // el MAX7219 arranca apagado
  display.setIntensity(0, 8);   // brillo de 0 a 15
  display.clearDisplay(0);
  display.setChar(0, 7, 'H', false);
  display.setDigit(0, 6, 0, false);   // una O
  display.setChar(0, 5, 'L', false);
  display.setChar(0, 4, 'A', false);
  delay(1500);
}

void loop() {
  mostrarNumero(millis() / 10);   // centésimas de segundo
  delay(10);
}
`;

const OLED_SH1106 = `// OLED de 1.3" (controlador SH1106) con U8g2: un reloj de manecillas con el tiempo desde el arranque.
// Ojo con el orden de las patas de este módulo: VDD, GND, SCK (a A5) y SDA (a A4).
#include <U8g2lib.h>
#include <Wire.h>

U8G2_SH1106_128X64_NONAME_F_HW_I2C u8g2(U8G2_R0, U8X8_PIN_NONE);

void manecilla(float fraccion, int largo) {
  float a = fraccion * 2 * PI - PI / 2;   // 0 = arriba
  u8g2.drawLine(32, 32, 32 + largo * cos(a), 32 + largo * sin(a));
}

void setup() {
  u8g2.begin();
}

void loop() {
  unsigned long s = millis() / 1000;
  u8g2.clearBuffer();
  u8g2.drawCircle(32, 32, 30);
  for (int i = 0; i < 12; i++) {   // marcas de las horas
    float a = i * PI / 6;
    u8g2.drawLine(32 + 25 * cos(a), 32 + 25 * sin(a), 32 + 29 * cos(a), 32 + 29 * sin(a));
  }
  manecilla((s % 60) / 60.0, 26);        // segundos
  manecilla((s / 60 % 60) / 60.0, 19);   // minutos
  u8g2.drawDisc(32, 32, 2);
  char texto[6];
  snprintf(texto, sizeof(texto), "%02lu:%02lu", s / 60 % 60, s % 60);
  u8g2.setFont(u8g2_font_logisoso16_tn);
  u8g2.drawStr(70, 40, texto);
  u8g2.sendBuffer();
}
`;

// Display de un dígito: resistencias en horizontal hacia fuera, cada segmento en su columna.
const sevenParts = [
  part('disp1', 'seven-segment', { common: 'cathode', color: 'red' }, at(BB, 'd13', 'seven-segment')),
  part('ra', 'resistor', { value: 220 }, at(BB, 'b16', 'resistor')),
  part('rb', 'resistor', { value: 220 }, at(BB, 'c17', 'resistor')),
  part('rc', 'resistor', { value: 220 }, at(BB, 'j16', 'resistor')),
  part('rd', 'resistor', { value: 220 }, at(BB, 'j10', 'resistor')),
  part('re', 'resistor', { value: 220 }, at(BB, 'i9', 'resistor')),
  part('rf', 'resistor', { value: 220 }, at(BB, 'b10', 'resistor')),
  part('rg', 'resistor', { value: 220 }, at(BB, 'c9', 'resistor')),
  part('rdp', 'resistor', { value: 220 }, at(BB, 'i17', 'resistor')),
];

// Barra de LEDs: cátodos arriba con su resistencia vertical al riel de GND (la columna 13 no tiene
// agujero en el riel: su resistencia va en la 18 con un puente).
const barResistors = [8, 9, 10, 11, 12, 18, 14, 15, 16, 17].map((col, i) =>
  part('r' + (i + 1), 'resistor', { value: 220 }, at(BB, 'a' + col, 'resistor', { rot: 90 })));

export const EXAMPLES = [
  {
    id: 'oled-adafruit',
    category: 'Pantallas',
    name: 'OLED 0.96″: texto y gráficos (Adafruit)',
    description: 'Adafruit_SSD1306 dibuja un título en la zona amarilla y una pelota que rebota en la azul. Solo 4 cables por I²C.',
    project: {
      name: 'OLED Adafruit',
      files: { 'sketch.ino': OLED_ADAFRUIT },
      parts: [UNO, part('oled1', 'oled-ssd1306', { color: 'yellow-blue' }, { x: 16, z: 64, rot: 0 })],
      wires: wires([
        ['oled1:GND', 'uno:GND.2', 'black'],
        ['oled1:VCC', 'uno:5V', 'red'],
        ['oled1:SCL', 'uno:A5', 'yellow'],
        ['oled1:SDA', 'uno:A4', 'blue'],
      ]),
    },
  },
  {
    id: 'oled-u8g2',
    category: 'Pantallas',
    name: 'OLED 0.96″ con U8g2: onda senoidal',
    description: 'La librería U8g2 con el búfer completo: fuentes de distintos tamaños y una onda que avanza.',
    project: {
      name: 'OLED U8g2',
      files: { 'sketch.ino': OLED_U8G2 },
      parts: [UNO, part('oled1', 'oled-ssd1306', { color: 'white' }, { x: 16, z: 64, rot: 0 })],
      wires: wires([
        ['oled1:GND', 'uno:GND.2', 'black'],
        ['oled1:VCC', 'uno:5V', 'red'],
        ['oled1:SCL', 'uno:A5', 'yellow'],
        ['oled1:SDA', 'uno:A4', 'blue'],
      ]),
    },
  },
  {
    id: 'oled-128x32',
    category: 'Pantallas',
    name: 'OLED 0.91″ (128×32): reloj',
    description: 'La pantalla alargada de 128×32: minutos y segundos en letra grande y una barra que se llena cada segundo.',
    project: {
      name: 'OLED 128x32',
      files: { 'sketch.ino': OLED32 },
      parts: [UNO, part('oled1', 'oled-128x32', { color: 'white' }, { x: 30, z: 58, rot: 0 })],
      wires: wires([
        ['oled1:GND', 'uno:GND.2', 'black'],
        ['oled1:VCC', 'uno:5V', 'red'],
        ['oled1:SCL', 'uno:A5', 'yellow'],
        ['oled1:SDA', 'uno:A4', 'blue'],
      ]),
    },
  },
  {
    id: 'oled-sh1106',
    category: 'Pantallas',
    name: 'OLED 1.3″ (SH1106) con U8g2: reloj de manecillas',
    description: 'La OLED de 1.3″ usa el controlador SH1106: con U8g2 se dibuja un reloj de manecillas. Sus patas van en orden VDD, GND, SCK, SDA.',
    project: {
      name: 'OLED SH1106',
      files: { 'sketch.ino': OLED_SH1106 },
      parts: [UNO, part('oled1', 'oled-sh1106', { color: 'white' }, { x: 16, z: 68, rot: 0 })],
      wires: wires([
        ['oled1:VCC', 'uno:5V', 'red'],
        ['oled1:GND', 'uno:GND.2', 'black'],
        ['oled1:SCL', 'uno:A5', 'yellow'],
        ['oled1:SDA', 'uno:A4', 'blue'],
      ]),
    },
  },
  {
    id: 'siete-segmentos',
    category: 'Pantallas',
    name: 'Display de 7 segmentos: contador 0–9',
    description: 'Un dígito de cátodo común con una resistencia de 220 Ω por segmento; el programa enciende los segmentos de cada número.',
    project: {
      name: 'Siete segmentos',
      files: { 'sketch.ino': SIETE_SEGMENTOS },
      parts: [UNO, BB, ...sevenParts],
      wires: wires([
        ['uno:2', 'bb1:e20', 'green'],
        ['uno:3', 'bb1:e21', 'green'],
        ['uno:4', 'bb1:f20', 'blue'],
        ['uno:5', 'bb1:f10', 'blue'],
        ['uno:6', 'bb1:f9', 'blue'],
        ['uno:7', 'bb1:e10', 'green'],
        ['uno:8', 'bb1:e9', 'green'],
        ['uno:9', 'bb1:f21', 'orange'],
        ['bb1:j15', 'bb1:bn12', 'black'],
        ['bb1:bn5', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'sevseg-cronometro',
    category: 'Pantallas',
    name: 'Display de 4 dígitos: cronómetro (SevSeg)',
    description: 'SevSeg multiplexa un display de 4 dígitos de cátodo común: 8 pines para los segmentos y 4 para los dígitos.',
    project: {
      name: 'Cronómetro SevSeg',
      files: { 'sketch.ino': SEVSEG },
      parts: [
        UNO,
        BB,
        part('disp1', 'seven-segment-4', { common: 'cathode', color: 'red' }, at(BB, 'd13', 'seven-segment-4')),
        ...[27, 28, 29, 30].map((col, i) => part('rd' + (i + 1), 'resistor', { value: 330 }, at(BB, 'g' + col, 'resistor', { rot: 90 }))),
      ],
      wires: wires([
        ['uno:2', 'bb1:j27', 'white'],
        ['uno:3', 'bb1:j28', 'white'],
        ['uno:4', 'bb1:j29', 'white'],
        ['uno:5', 'bb1:j30', 'white'],
        ['bb1:a27', 'bb1:a13', 'gray'],
        ['bb1:b28', 'bb1:a16', 'gray'],
        ['bb1:c29', 'bb1:a17', 'gray'],
        ['bb1:d30', 'bb1:j18', 'gray'],
        ['uno:6', 'bb1:a14', 'green'],
        ['uno:7', 'bb1:a18', 'green'],
        ['uno:8', 'bb1:j16', 'green'],
        ['uno:9', 'bb1:j14', 'green'],
        ['uno:10', 'bb1:j13', 'green'],
        ['uno:11', 'bb1:a15', 'green'],
        ['uno:12', 'bb1:j17', 'green'],
        ['uno:13', 'bb1:j15', 'orange'],
      ]),
    },
  },
  {
    id: 'tm1637-reloj',
    category: 'Pantallas',
    name: 'Reloj con display TM1637',
    description: 'El módulo TM1637 muestra «HOLA» y luego minutos y segundos con los dos puntos parpadeando. Solo 2 pines de datos.',
    project: {
      name: 'Reloj TM1637',
      files: { 'sketch.ino': TM1637_RELOJ },
      parts: [UNO, part('tm1', 'tm1637', { color: 'red', dots: 'colon' }, { x: -24, z: -68, rot: 0 })],
      wires: wires([
        ['tm1:CLK', 'uno:2', 'yellow'],
        ['tm1:DIO', 'uno:3', 'orange'],
        ['tm1:VCC', 'uno:5V', 'red'],
        ['tm1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'matriz-max7219',
    category: 'Pantallas',
    name: 'Matriz LED 8×8 con MAX7219 (LedControl)',
    description: 'Caras animadas y un barrido LED por LED con la librería LedControl (3 pines de datos por bit-bang).',
    project: {
      name: 'Matriz 8x8',
      files: { 'sketch.ino': MATRIZ_LEDCONTROL },
      parts: [UNO, part('mx1', 'max7219-matrix', {}, { x: -32, z: -74, rot: 0 })],
      wires: wires([
        ['mx1:VCC', 'uno:5V', 'red'],
        ['mx1:GND', 'uno:GND.1', 'black'],
        ['mx1:DIN', 'uno:12', 'orange'],
        ['mx1:CS', 'uno:10', 'yellow'],
        ['mx1:CLK', 'uno:11', 'green'],
      ]),
    },
  },
  {
    id: 'parola-texto',
    category: 'Pantallas',
    name: 'Texto que se desplaza (MD_Parola, 4 matrices)',
    description: 'Una placa FC-16 con cuatro matrices 8×8 en cadena muestra un letrero con MD_Parola usando SPI por hardware.',
    project: {
      name: 'Letrero MD_Parola',
      files: { 'sketch.ino': PAROLA },
      parts: [UNO, part('mx1', 'max7219-matrix4', {}, { x: -34, z: -80, rot: 0 })],
      wires: wires([
        ['mx1:VCC', 'uno:5V', 'red'],
        ['mx1:GND', 'uno:GND.1', 'black'],
        ['mx1:DIN', 'uno:11', 'orange'],
        ['mx1:CS', 'uno:10', 'yellow'],
        ['mx1:CLK', 'uno:13', 'green'],
      ]),
    },
  },
  {
    id: 'max7219-8digitos',
    category: 'Pantallas',
    name: 'Display de 8 dígitos MAX7219 (LedControl)',
    description: 'Un módulo de 8 dígitos con el MAX7219 muestra «HOLA» y luego un contador de centésimas con setDigit.',
    project: {
      name: 'Display 8 dígitos',
      files: { 'sketch.ino': MAX7SEG_CODE },
      parts: [UNO, part('d1', 'max7219-7seg', { color: 'red' }, { x: 4, z: -62, rot: 0 })],
      wires: wires([
        ['d1:VCC', 'uno:5V', 'red'],
        ['d1:GND', 'uno:GND.1', 'black'],
        ['d1:DIN', 'uno:12', 'orange'],
        ['d1:CS', 'uno:10', 'yellow'],
        ['d1:CLK', 'uno:11', 'green'],
      ]),
    },
  },
  {
    id: 'neopixel-anillo',
    category: 'Luces',
    name: 'Anillo NeoPixel: arcoíris (Adafruit_NeoPixel)',
    description: 'Un anillo de 16 LEDs WS2812B controlado por un solo pin: arcoíris giratorio y un cometa con estela.',
    project: {
      name: 'Anillo NeoPixel',
      files: { 'sketch.ino': ANILLO },
      parts: [UNO, part('ring1', 'neopixel-ring', { pixels: 16 }, { x: 22, z: -78, rot: 0 })],
      wires: wires([
        ['ring1:DIN', 'uno:6', 'green'],
        ['ring1:VCC', 'uno:5V', 'red'],
        ['ring1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'fastled-escaner',
    category: 'Luces',
    name: 'Escáner de luz con FastLED',
    description: 'Una tira de 8 NeoPixel con la librería FastLED: un punto rojo que va y viene dejando estela.',
    project: {
      name: 'Escáner FastLED',
      files: { 'sketch.ino': ESCANER },
      parts: [UNO, part('st1', 'neopixel-stick', {}, { x: 12, z: -66, rot: 0 })],
      wires: wires([
        ['st1:DIN', 'uno:5', 'green'],
        ['st1:VCC', 'uno:5V', 'red'],
        ['st1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'neopixel-matriz',
    category: 'Luces',
    name: 'Matriz NeoPixel 8×8: corazón que late',
    description: 'Los 64 LEDs de la matriz van en filas (el 0 arriba a la izquierda): un corazón que late sobre un arcoíris.',
    project: {
      name: 'Matriz NeoPixel',
      files: { 'sketch.ino': MATRIZ_NEOPIXEL },
      parts: [UNO, part('m1', 'neopixel-matrix', { layout: 'progressive' }, { x: 6, z: -100, rot: 0 })],
      wires: wires([
        ['m1:DIN', 'uno:3', 'green'],
        ['m1:VCC', 'uno:5V', 'red'],
        ['m1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'neopixel-anillo-rgbw',
    category: 'Luces',
    name: 'Anillo NeoPixel RGBW: el canal blanco',
    description: 'Un anillo de 16 LEDs SK6812 con LED blanco (NEO_GRBW, 32 bits por LED): compara el blanco de rojo + verde + azul con el del LED W, y mira cómo respira.',
    project: {
      name: 'Anillo NeoPixel RGBW',
      files: { 'sketch.ino': ANILLO_RGBW },
      parts: [UNO, part('ring1', 'neopixel-ring', { pixels: 16, leds: 'rgbw-natural' }, { x: 22, z: -78, rot: 0 })],
      wires: wires([
        ['ring1:DIN', 'uno:6', 'green'],
        ['ring1:VCC', 'uno:5V', 'red'],
        ['ring1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'neopixel-tira-rgbw',
    category: 'Luces',
    name: 'Tira NeoPixel RGBW: del rojo al blanco',
    description: 'Una tira de 8 LEDs SK6812: el rojo se apaga y el LED blanco (cuarto valor de Color) se enciende; en medio se mezclan.',
    project: {
      name: 'Tira NeoPixel RGBW',
      files: { 'sketch.ino': TIRA_RGBW },
      parts: [UNO, part('st1', 'neopixel-stick', { leds: 'rgbw-warm' }, { x: 12, z: -66, rot: 0 })],
      wires: wires([
        ['st1:DIN', 'uno:5', 'green'],
        ['st1:VCC', 'uno:5V', 'red'],
        ['st1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'neopixel-matriz-rgbw',
    category: 'Luces',
    name: 'Matriz NeoPixel RGBW 8×8: nieve',
    description: 'Copos de nieve hechos con el LED blanco (canal W) de una matriz SK6812 de 8×8 que caen sobre un fondo azul oscuro.',
    project: {
      name: 'Matriz NeoPixel RGBW',
      files: { 'sketch.ino': MATRIZ_RGBW },
      parts: [UNO, part('m1', 'neopixel-matrix', { layout: 'progressive', leds: 'rgbw-cool' }, { x: 6, z: -100, rot: 0 })],
      wires: wires([
        ['m1:DIN', 'uno:3', 'green'],
        ['m1:VCC', 'uno:5V', 'red'],
        ['m1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'barra-leds',
    category: 'Luces',
    name: 'Barra de 10 LEDs con perilla',
    description: 'La perilla en A0 decide cuántos LEDs de la barra se encienden (como el ejemplo «barGraph» de Arduino).',
    project: {
      name: 'Barra de LEDs',
      files: { 'sketch.ino': BARRA },
      parts: [
        UNO,
        BB,
        part('bar1', 'led-bar', { color: 'multi' }, at(BB, 'f8', 'led-bar')),
        ...barResistors,
        part('pot1', 'potentiometer', { value: 0.6 }, at(BB, 'f22', 'potentiometer')),
      ],
      wires: wires([
        ...Array.from({ length: 10 }, (_, i) => ['uno:' + (2 + i), 'bb1:j' + (8 + i), i < 5 ? 'green' : i < 8 ? 'yellow' : 'red']),
        ['bb1:b13', 'bb1:b18', 'gray'],
        ['uno:GND.1', 'bb1:bn1', 'black'],
        ['bb1:bn2', 'bb1:tn2', 'black'],
        ['uno:5V', 'bb1:bp25', 'red'],
        ['bb1:j22', 'bb1:bn18', 'black'],
        ['bb1:j24', 'bb1:bp20', 'red'],
        ['bb1:j23', 'uno:A0', 'orange'],
      ]),
    },
  },
  {
    id: 'neopixel-5mm',
    category: 'Luces',
    name: 'Tres NeoPixel de 5 mm en cadena',
    description: 'LEDs RGB direccionables de 5 mm en la protoboard: el DOUT de cada uno comparte columna con el DIN del siguiente.',
    project: {
      name: 'NeoPixel de 5 mm',
      files: { 'sketch.ino': NEOPIXEL_5MM },
      parts: [
        UNO,
        BB,
        part('px1', 'neopixel', {}, at(BB, 'h5', 'neopixel')),
        part('px2', 'neopixel', {}, at(BB, 'g8', 'neopixel')),
        part('px3', 'neopixel', {}, at(BB, 'f11', 'neopixel')),
      ],
      wires: wires([
        ['uno:6', 'bb1:j5', 'green'],
        ['bb1:j6', 'bb1:bp5', 'red'],
        ['bb1:j7', 'bb1:bn6', 'black'],
        ['bb1:j9', 'bb1:bp7', 'red'],
        ['bb1:j10', 'bb1:bn8', 'black'],
        ['bb1:j12', 'bb1:bp10', 'red'],
        ['bb1:j13', 'bb1:bn11', 'black'],
        ['uno:5V', 'bb1:bp1', 'red'],
        ['uno:GND.1', 'bb1:bn1', 'black'],
      ]),
    },
  },
];
